var styles = {
  "Collapsible": "Polaris-Collapsible",
  "isFullyClosed": "Polaris-Collapsible--isFullyClosed",
  "expandOnPrint": "Polaris-Collapsible--expandOnPrint",
  "inline": "Polaris-Collapsible--inline",
  "animateIn": "Polaris-Collapsible--animateIn"
};

export { styles as default };
